export function inviteBox (orderId, referralLabel, referralInstruction, referralSourceSpreadMsgInOrderSummary, moreInfoLink, inPage) {
	const domain = `https://${window.location.host}`
	const prefix = `${domain}/referral/from/o?e=${orderId}&next=`
	const shareLink = (moreInfoLink !== '') ? `${prefix}${moreInfoLink}` : `${prefix}https://www.shenyun.com/tickets`
	return `
  <div class="InviteBox">
            <h1 class="InviteBox--Label a-center mt-20">${referralLabel}</h1>
            <div class="InviteBox--Sub mb-20">${referralInstruction}</div>
            <form id="Referral--Form" class="Form__GroupFull needs-validation" >
                <div class="Form__ItemFull mb-10">
                    <input name="name" type="text" class="Form__Input" id="ReferralName" autocomplete="on" placeholder="${window.myvars.yourName}" required>
                    <div class="invalid-feedback">${window.myvars.enterName}</div>
                </div>
                <div class="Form__ItemFull mb-10">
                    <input name="to" type="email" multiple class="Form__Input" id="ReferralEmail" autocomplete="on" placeholder="${window.myvars.enterFriendsEmail}" required>
                    <div class="invalid-feedback">${window.myvars.enterFriendsEmail}</div>
                </div>
                <div class="Form__ItemFull mb-15">
                    <textarea name="content" type="text" class="Form__Textarea" id="ReferralEmailContent" autocomplete="on">${referralSourceSpreadMsgInOrderSummary}</textarea>
                </div>

                <div class="CheckboxStyle mb-10">
                    <label>
                        <input type="checkbox" name="sendMeCopy" value="1" onclick="onClickHandler(this)" id="sendMeCopy">
                        <span class="checkbox-material"><span class="check"></span></span>
                        <span class="checkbox-label">${window.myvars.sendMeCp}</span>
                    </label>
                </div>
                <div class="Form__ItemFull mb-15" id="MyEmailWrapper" style="display:none">
                    <input name="from" type="email" class="Form__Input" id="MyEmail" autocomplete="on" placeholder="${window.myvars.yourEmail}">
                    <div class="invalid-feedback">${window.myvars.enterEmail}</div>
                </div>

            </form>
            <button class="Orange--PrimaryBtn w100" type="submit" onclick="ajaxSubmitInvite('${orderId}', ${inPage})">
							<span class="btn__content">${window.myvars.sendEmail} ></span>
							<svg class="icon-svg icon-svg--size-18 btn__spinner icon-svg--spinner-button" aria-hidden="true" focusable="false"> <use xlink:href="#spinner-button"></use></svg>
            </button>
            <footer class="InviteBox--Footer">
                <div class="hidden" id="copyLinkPlaceHolder" data-share-link="${shareLink}">${shareLink}</div>
                <div class="Icon__CopyLink hand" onclick="copyOnClickReferral(this)">
									<svg class="icon-svg icon-svg--size-20 rotate-45" aria-hidden="true" focusable="false">
										<use xlink:href="#Link1"></use>
									</svg>
                </div>
                <div class="ReferralShare--FbIcon hand" id="fb-share-btn" onclick="fb_share('${shareLink}')">
                    <svg class="icon-svg icon-svg--size-20" aria-hidden="true" focusable="false">
                        <use xlink:href="#FbIcon"></use>
                    </svg>
                </div>
            </footer>
        </div>
  `
}




function InviteAjaxBoxContainer (orderId, referralLabel, referralInstruction, referralSourceSpreadMsgInOrderSummary, moreInfoLink) {
	return `
    <div class="InviteAjaxBox__Wrapper">
      <div class="OutSideClose hand" onclick="Swal.clickConfirm()">
      	<svg class="icon-svg icon-svg--size-32" aria-hidden="true" focusable="false">
        	<use xlink:href="#close"></use>
        </svg></div>
				<div class="InviteAjaxBoxContainer">
							<aside class="InviteAjax__Left"></aside>
							${inviteBox(orderId, referralLabel, referralInstruction, referralSourceSpreadMsgInOrderSummary, moreInfoLink)}
				</div>
    </div>
	`
}

export default InviteAjaxBoxContainer

